import { createAsyncThunk } from "@reduxjs/toolkit";
import AuthServices from "../../services/authServices";
import { getErrorMessage } from "../../util/GetError";

export const registerUser = createAsyncThunk(
  "auth/register",
  async (details, { rejectWithValue }) => {
    try {
      const { data } = await AuthServices.register(details);
      return data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const googleRegister = createAsyncThunk(
  "auth/google-register",
  async (details, { rejectWithValue }) => {
    try {
      const { data } = await AuthServices.googleRegister(details);
      return data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const userLogin = createAsyncThunk(
  "auth/login",
  async ({ email, password }, { rejectWithValue }) => {
    try {
      // console.log (email, password);
      const { data } = await AuthServices.login({ email, password });
      // store user's token in local storage
      // console.log(data);
      localStorage.setItem("userDetails", JSON.stringify(data));
      localStorage.removeItem("showedFeedback");
      // localStorage.setItem('userInfo',data);
      return data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const googleLogin = createAsyncThunk(
  "auth/google-login",
  async ({ token }, { rejectWithValue }) => {
    try {
      // console.log (email, password);
      const { data } = await AuthServices.googleLogin({ token });
      // store user's token in local storage
      // console.log(data);
      localStorage.setItem("userDetails", JSON.stringify(data));
      // localStorage.setItem('userInfo',data);
      return data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const microsoftLogin = createAsyncThunk(
  "auth/microsoft-login",
  async ({ token }, { rejectWithValue }) => {
    try {
      // console.log (email, password);
      const { data } = await AuthServices.microsoftLogin({ token });
      // store user's token in local storage
      // console.log(data);
      localStorage.setItem("userDetails", JSON.stringify(data));
      // localStorage.setItem('userInfo',data);
      return data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const microsoftRegister = createAsyncThunk(
  "auth/microsoft-register",
  async (details, { rejectWithValue }) => {
    try {
      const { data } = await AuthServices.microsoftRegister(details);
      return data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);
